import { format } from "date-fns";

/**
 * Дата из Redux → `selected` для DateRangePicker, как defaultDate() легаси
 * datePicker: пустой конец диапазона — сегодня. В сторе фактически лежат Date
 * из react-datepicker, хотя тип объявлен строками.
 */
export const toRangeSelected = (
  date: string | null | [string | null, string | null] | (Date | null)[]
): Date[] | false => {
  if (!date) return false;
  if (Array.isArray(date)) {
    return [
      date[0] ? new Date(date[0]) : new Date(),
      date[1] ? new Date(date[1]) : new Date(),
    ];
  }
  const day = new Date(date);
  return [day, new Date(day)];
};

/** Выбрана только дата начала — ToDate = FromDate, как в легаси datePicker. */
export const resolvePartialEnd = (dates: [Date | null, Date | null]): string | null => {
  const [start, end] = dates;
  if (!start || end) return null;
  return format(start, "yyyyMMdd");
};
